import { InjectionToken } from '@angular/core';

export const SERVER_TOKEN = new InjectionToken<string | null>('SERVER_TOKEN');

